import FormV1 from "../../components/form_builder/elements/form/FormV1.vue";
import RowV1 from "../../components/form_builder/elements/row/RowV1.vue";
import ColumnV1 from "../../components/form_builder/elements/column/ColumnV1.vue";
import textV1 from "./components/text/textV1";
import textInputV1 from "./components/text_input/textInputV1";
import textInputAiAutofillV1 from "./components/text_input_ai_autofill/textInputAiAutofillV1";
import dropdownV1 from "./components/dropdown/dropdownV1";
import dropdownV2 from "./components/dropdown/dropdownV2";
import documentPickerV1 from "./components/document_picker/documentPickerV1";
import datePickerV1 from "./components/date_picker/datePickerV1";
import timePickerV1 from "./components/time_picker/timePickerV1";
import emailInputV1 from "./components/email_input/emailInputV1";
import phoneInputV1 from "./components/phone_input/phoneInputV1";
import numberInputV1 from "./components/number_input/numberInputV1";
import passwordInputV1 from "./components/password_input/passwordInputV1";
import textareaV1 from "./components/textarea/textareaV1";
import singleChoiceV1 from "./components/single_choice/singleChoiceV1";
import multipleChoiceV1 from "./components/multiple_choice/multipleChoiceV1";
import signatureV1 from "./components/signature/signatureV1";
import pictureV1 from "./components/picture/pictureV1";
import datatableV1 from "./components/datatable/datatableV1";
import crudV1 from "./components/crud/crudV1";
import formHeaderV1 from "./components/form_header/formHeaderV1";
import frequencyDurationV1 from "./components/frequency_duration/frequencyDurationV1";
import tableV1 from "./components/table/tableV1";
import eocVitalsV1 from "./components/eoc_vitals/eocVitalsV1";
import eocDiagnosisCodesV1 from "./components/eoc_diagnosis_codes/eocDiagnosisCodesV1";
import patientAllergiesV1 from "./components/patient_allergies/patientAllergiesV1";
import sectionHeaderV1 from "./components/section_header/sectionHeaderV1";
import htmlV1 from "./components/html/htmlV1";
import booleanV1 from "./components/boolean/booleanV1";
import treatmentPlanObjectivesV1 from "./components/treatment_plan_objectives/treatmentPlanObjectivesV1";
import assessmentQuestionV1 from "./components/assessment_question/assessmentQuestionV1";
import eocVitalsV2 from "./components/eoc_vitals/eocVitalsV2";
import eocMedicationsV1 from "./components/eoc_medications/eocMedicationsV1";
import eocActiveMedicationsV1 from "./components/eoc_active_medications/eocActiveMedicationsV1";
import pageBreakV1 from "./components/page_break/pageBreakV1";
import patientDoseSpotActiveMedicationsV1 from "./components/patient_dose_spot_active_medications/patientDoseSpotActiveMedicationsV1";
import emarScheduledTreatmentEventsV1 from "./components/emar_scheduled_treatment_events/emarScheduledTreatmentEventsV1";
import emarPatientVitalsV1 from "./components/emar_patient_vitals/emarPatientVitalsV1";
import emarPatientDispenseReportV1 from "./components/emar_patient_dispense_report/emarPatientDispenseReportV1";

export const elementVersions = {
  Form: {
    type: "layout",
    lastVersion: "1",
    versions: {
      1: {
        componentName: "fb-form-v1",
        component: FormV1,
        defaultAttrs: {
          properties: {
            script: "",
            scoreFunctionBody: "",
            treatmentPlanObjectivesMap: "",
            hideViewSeparationLines: false,
            style: {},
            modalSize: "lg",
          },
        },
      },
    },
  },
  Row: {
    type: "layout",
    lastVersion: "1",
    versions: {
      1: {
        componentName: "fb-row-v1",
        component: RowV1,
        defaultAttrs: {
          properties: {
            style: {},
          },
        },
      },
    },
  },
  Column: {
    type: "layout",
    lastVersion: "1",
    versions: {
      1: {
        componentName: "fb-column-v1",
        component: ColumnV1,
        defaultAttrs: {
          properties: {
            style: {},
          },
        },
      },
    },
  },
  Text: {
    type: "component",
    additionalInfo: true,
    label: "Text",
    lastVersion: "1",
    icon: "card-text",
    versions: {
      1: textV1,
    },
  },
  TextInput: {
    type: "component",
    additionalInfo: true,
    label: "Text Input",
    lastVersion: "1",
    icon: "textarea-t",
    versions: {
      1: textInputV1,
    },
  },
  TextInputAiAutofill: {
    type: "component",
    additionalInfo: true,
    label: "Text Input (AI Autofill)",
    lastVersion: "1",
    icon: "window-dock",
    versions: {
      1: textInputAiAutofillV1 ,
    },
  },
  EmailInput: {
    type: "component",
    additionalInfo: true,
    label: "Email Input",
    lastVersion: "1",
    icon: "envelope",
    versions: {
      1: emailInputV1,
    },
  },
  PhoneInput: {
    type: "component",
    additionalInfo: true,
    label: "Phone Input",
    lastVersion: "1",
    icon: "phone",
    versions: {
      1: phoneInputV1,
    },
  },
  NumberInput: {
    type: "component",
    additionalInfo: true,
    label: "Number Input",
    lastVersion: "1",
    icon: "hash",
    versions: {
      1: numberInputV1,
    },
  },
  PasswordInput: {
    type: "component",
    label: "Password Input",
    lastVersion: "1",
    icon: "asterisk",
    versions: {
      1: passwordInputV1,
    },
  },
  Dropdown: {
    type: "component",
    additionalInfo: true,
    label: "Dropdown",
    lastVersion: "2",
    icon: "caret-down-fill",
    versions: {
      1: dropdownV1,
      2: dropdownV2,
    },
  },
  DatePicker: {
    type: "component",
    additionalInfo: true,
    label: "Date Picker",
    lastVersion: "1",
    icon: "calendar",
    versions: {
      1: datePickerV1,
    },
  },
  TimePicker: {
    type: "component",
    additionalInfo: true,
    label: "Time Picker",
    lastVersion: "1",
    icon: "clock",
    versions: {
      1: timePickerV1,
    },
  },
  Textarea: {
    type: "component",
    additionalInfo: true,
    label: "Textarea",
    lastVersion: "1",
    icon: "textarea-t",
    versions: {
      1: textareaV1,
    },
  },
  SingleChoice: {
    type: "component",
    additionalInfo: true,
    label: "Single Choice",
    lastVersion: "1",
    icon: "list-ul",
    versions: {
      1: singleChoiceV1,
    },
  },
  MultipleChoice: {
    type: "component",
    additionalInfo: true,
    label: "Multiple Choice",
    lastVersion: "1",
    icon: "list-check",
    versions: {
      1: multipleChoiceV1,
    },
  },
  Signature: {
    type: "component",
    label: "Signature",
    lastVersion: "1",
    icon: "pen",
    versions: {
      1: signatureV1,
    },
  },
  Picture: {
    type: "component",
    label: "Picture",
    lastVersion: "1",
    icon: "camera",
    versions: {
      1: pictureV1,
    },
  },
  Datatable: {
    type: "component",
    advanced: true,
    alwaysVisible: true,
    label: "Datatable",
    lastVersion: "1",
    icon: "table",
    versions: {
      1: datatableV1,
    },
  },
  Crud: {
    type: "component",
    advanced: true,
    builderEnabled: true,
    label: "Crud",
    lastVersion: "1",
    icon: "table",
    versions: {
      1: crudV1,
    },
    versionLayoutProperties: {
      1: ["formLayout", "listItemLayout"],
    },
  },
  FrequencyDuration: {
    type: "component",
    advanced: true,
    label: "Frequency Duration",
    lastVersion: "1",
    icon: "caret-down-fill",
    versions: {
      1: frequencyDurationV1,
    },
  },
  Table: {
    type: "component",
    advanced: true,
    label: "Table",
    lastVersion: "1",
    icon: "table",
    versions: {
      1: tableV1,
    },
  },
  Header: {
    type: "component",
    listHidden: true,
    label: "Form Header",
    lastVersion: "1",
    icon: "file-earmark-arrow-up",
    versions: {
      1: formHeaderV1,
    },
  },
  SectionHeader: {
    type: "component",
    label: "Section Header",
    lastVersion: "1",
    icon: "file-earmark-arrow-up",
    versions: {
      1: sectionHeaderV1,
    },
  },
  Html: {
    type: "component",
    advanced: true,
    label: "Html",
    lastVersion: "1",
    icon: "code",
    versions: {
      1: htmlV1,
    },
  },
  Boolean: {
    type: "component",
    advanced: true,
    label: "Checkbox",
    lastVersion: "1",
    icon: "check",
    versions: {
      1: booleanV1,
    },
  },
  FormDropdown: {
    type: "component",
    advanced: true,
    alwaysVisible: true,
    label: "Document Picker",
    lastVersion: "1",
    icon: "folder",
    versions: {
      1: documentPickerV1,
    },
  },
  ClientVitals: {
    type: "component",
    advanced: true,
    alwaysVisible: true,
    label: "Patient Vitals",
    lastVersion: "2",
    icon: "table",
    versions: {
      1: eocVitalsV1,
      2: eocVitalsV2,
    },
  },
  ClientDiagnosisCodes: {
    type: "component",
    advanced: true,
    alwaysVisible: true,
    label: "Patient Diagnosis Codes",
    lastVersion: "1",
    icon: "table",
    versions: {
      1: eocDiagnosisCodesV1,
    },
  },
  ClientAllergies: {
    type: "component",
    advanced: true,
    alwaysVisible: true,
    label: "Patient Allergies",
    lastVersion: "1",
    icon: "table",
    versions: {
      1: patientAllergiesV1,
    },
  },
  TreatmentPlanObjectives: {
    type: "component",
    advanced: true,
    label: "Treatment Plan Objectives",
    lastVersion: "1",
    icon: "check",
    versions: {
      1: treatmentPlanObjectivesV1,
    },
  },
  AssessmentQuestion: {
    type: "component",
    additionalInfo: true,
    label: "Assessment Question",
    lastVersion: "1",
    icon: "list-ul",
    versions: {
      1: assessmentQuestionV1,
    },
  },
  ClientMedications: {
    type: "component",
    advanced: true,
    alwaysVisible: true,
    label: "Patient Medications",
    lastVersion: "1",
    icon: "table",
    versions: {
      1: eocMedicationsV1,
    },
  },
  ActiveMedications: {
    type: "component",
    advanced: true,
    alwaysVisible: true,
    label: "Active Medications",
    lastVersion: "1",
    icon: "table",
    versions: {
      1: eocActiveMedicationsV1,
    },
  },
  PageBreak: {
    type: "component",
    additionalInfo: true,
    label: "Page Break",
    lastVersion: "1",
    icon: "file-break",
    versions: {
      1: pageBreakV1,
    },
  },
  DoseSpotActiveMedications: {
    type: "component",
    advanced: true,
    alwaysVisible: true,
    label: "Dose Spot Active Medications",
    lastVersion: "1",
    icon: "table",
    versions: {
      1: patientDoseSpotActiveMedicationsV1,
    },
  },
  EmarScheduledTreatmentEvents: {
    type: "component",
    advanced: true,
    alwaysVisible: true,
    label: "Emar Scheduled Treatment Events",
    lastVersion: "1",
    icon: "table",
    versions: {
      1: emarScheduledTreatmentEventsV1,
    },
  },
  EmarPatientVitals: {
    type: "component",
    advanced: true,
    alwaysVisible: true,
    label: "Emar Patient Vitals",
    lastVersion: "1",
    icon: "table",
    versions: {
      1: emarPatientVitalsV1,
    },
  },
  EmarPatientDispenseReport: {
    type: "component",
    advanced: true,
    alwaysVisible: true,
    label: "Emar Patient Dispense Report",
    lastVersion: "1",
    icon: "table",
    versions: {
      1: emarPatientDispenseReportV1,
    },
  },
};
